<template>
  <section>
    <b-card>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <h5 class="mb-0">
          Markalar
        </h5>
        <b-input-group
          size="sm"
          class="ml-1"
          style="width: 520px;"
        >
          <b-form-input
            v-model="searchBrand"
          />
          <b-input-group-append>
            <b-button
              size="sm"
              variant="primary"
              @click="addAllFilteredBrands"
            >
              Tümünü ekle
            </b-button>
            <b-button
              size="sm"
              variant="outline-danger"
              @click="removeAllFilteredBrands"
            >
              Tümünü kaldır
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="showAll = !showAll"
            >
              {{ showAll ? 'Tümünü Gizle' : 'Tümünü Göster' }}
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <b-badge
        v-for="brand in brands"
        :key="brand.key"
        :variant="selectedBrandsFromStore.includes(brand) ? 'primary' : 'secondary'"
        class="mr-1 mb-1"
        @click="addRemoveBrand(brand)"
      >
        {{ brand.value }}
      </b-badge>
    </b-card>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Brands',
  data() {
    return {
      searchBrand: '',
      showAll: false,
    }
  },
  computed: {
    ...mapGetters('tySearchProduct', {
      brandsFromStore: '_brands',
      selectedBrandsFromStore: '_selectedBrands',
    }),
    brands() {
      let list = this.brandsFromStore
      if (this.searchBrand) {
        list = this.brandsFromStore.filter(brand => brand.value.toLowerCase().includes(this.searchBrand.toLowerCase()))
      }
      return this.showAll ? list : list.slice(0, 10)
    },
  },
  methods: {
    addRemoveBrand(brand) {
      if (this.selectedBrandsFromStore.includes(brand)) {
        this.$store.commit('tySearchProduct/removeSelectedBrand', brand)
      } else {
        this.$store.commit('tySearchProduct/addSelectedBrand', brand)
      }
    },
    addAllFilteredBrands() {
      this.brands.forEach(brand => {
        this.$store.commit('tySearchProduct/addSelectedBrand', brand)
      })
    },
    removeAllFilteredBrands() {
      this.brands.forEach(brand => {
        this.$store.commit('tySearchProduct/removeSelectedBrand', brand)
      })
    },
  },
}

</script>
